import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';

export class FrequencyPeriod extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static FrequencyPeriodProperties: (
    | {
        property: keyof FrequencyPeriod;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof FrequencyPeriod;
        type: 'alias';
      }
    | {
        property: keyof FrequencyPeriod;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'periodName', type: 'column', dataType: 'string' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' }
  ];

  static {
    FrequencyPeriod.FrequencyPeriodProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        FrequencyPeriod.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        FrequencyPeriod.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        FrequencyPeriod.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(FrequencyPeriodObject: Partial<FrequencyPeriod>) {
    super();

    FrequencyPeriod.FrequencyPeriodProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = FrequencyPeriodObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number | null;
  periodName?: string | null;
  createdAt?: Date | null;
  updatedAt?: Date | null;
}
